<template>
  <div>
    <section class="content">
      <RouterView />
    </section>
    <Loading />

    <H5LoginIn />

    <H5ImageSearchGuide v-if="imageSearchGuidePageVisible" />
    <H5ImageSearch v-if="imageSearchDialogVisible" />

    <!-- 分类弹窗 -->
    <Teleport to="body">
      <H5Dialog
        v-model="categoryDialogVisible"
        height="100%"
        style="z-index: 9999;"
      >
        <H5CategoryDialog />
      </H5Dialog>
    </Teleport>
  </div>
</template>

<script setup>
import H5Dialog from '@/components/H5/H5Dialog/index.vue'
import H5CategoryDialog from '@/components/H5/H5CategoryDialog/index.vue'
import H5ImageSearchGuide from '@/components/H5/H5ImageSearchGuide/index.vue'
import H5ImageSearch from '@/components/H5/H5ImageSearch/index.vue'
import Loading from '@/components/Loading/index.vue'
import { onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import H5LoginIn from '@/components/H5/H5LoginIn/index.vue'

const store = useStore()
const route = useRoute()
const router = useRouter()

const imageSearchGuidePageVisible = computed(() => store.state.h5Module.imageSearchGuidePageVisible)
const imageSearchDialogVisible = computed(() => store.state.h5Module.imageSearchDialogVisible)
const categoryDialogVisible = computed(() => store.state.h5Module.categoryDialogVisible)

watch(() => route.fullPath, (value) => {
  openImageSearch()
})

onMounted(() => {
  waitForElement().then(element => {
    element.addEventListener('click', function () {
      gaAnalytics('mp_consultation_click', 'mp_consultation_click')
      buriedPointUtil({ eventId: 'MPWH202' })
    })
  })
  openImageSearch()
})

const waitForElement = () => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const element = document.querySelector('.intercom-launcher')
          if (element) {
            observer.disconnect() // 找到元素后停止观察
            resolve(element) // 返回找到的元素
          }
        }
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

const openImageSearch = () => {
  const fullPath = route.fullPath
  if (fullPath.includes('search?offerId') || fullPath.includes('search?imageId')) {
    const imageSearchInfo = JSON.parse(localStorage.getItem('imageSearchInfo'))
    if (imageSearchInfo) {
      store.commit('h5Module/showImageSearchDialog', imageSearchInfo)
    } else {
      router.push('/')
    }
  }
}
</script>

<style lang="less">
@import './index.less';
</style>

<style lang="less" scoped>
/* PC端样式 */
@media (min-width: 768px) {
  :global(.intercom-launcher) {
    right: 144px !important;
  }
}

.custom-category-dialog {
  ::v-deep(.popup-content) {
    border-radius: 0;
    background-color: transparent;
  }
}
</style>
